import * as actionTypes from '../../types/tickets';
import * as actionTypesGeneral from '../../types/general';

export const initialState = {
  error: false,
  isFetching: false,
  deleteFetching: false,
  replyFetching: false,
  addFetching: false,
  massFetching: false,
  paginationFetching: true,
  staffFetching: false,
  statuses: [],
  staff: [],
  user_levels: [],
  neededListRequest: true,
  view: {},
  activeViewId: -1,
};

const tickets = (state = initialState, action) => {
  switch (action.type) {
  case actionTypes.CLEAR_FILTERS: {
    return {
      ...state,
    };
  }
  case actionTypes.DELETE_TICKET:
  case actionTypes.CLOSE_TICKET:
  case actionTypes.UNREAD_MESSAGE: {
    return {
      ...state,
      neededListRequest: false,
      isFetching: true,
      deleteFetching: true,
    };
  }

  case actionTypes.UNREAD_MESSAGE_ERROR:
  case actionTypes.DELETE_TICKET_ERROR:
  case actionTypes.CLOSE_TICKET_ERROR: {
    return {
      ...state,
      error: action.error_message,
      deleteFetching: false,
      neededListRequest: true,
    };
  }

  case actionTypes.CLOSE_TICKET_SUCCESS:
  case actionTypes.DELETE_TICKET_SUCCESS:
  case actionTypes.UNREAD_MESSAGE_SUCCESS: {
    return {
      ...state,
      neededListRequest: true,
      deleteFetching: false,
    };
  }

  case actionTypes.GET_TICKET_VIEW:
  case actionTypes.GET_LIST:
  case actionTypes.GET_CONFIG: {
    return {
      ...state,
      isFetching: true,
    };
  }
  case actionTypes.GET_PAGINATION: {
    return {
      ...state,
      paginationFetching: true,
    };
  }
  case actionTypes.GET_PAGINATION_SUCCESS: {
    return {
      ...state,
      pagination: action.data,
      paginationFetching: false,
    };
  }
  case actionTypes.GET_PAGINATION_ERROR: {
    return {
      ...state,
      paginationFetching: false,
    };
  }
  case actionTypes.ASSIGN_TICKET:
  case actionTypes.ADD_TICKET: {
    return {
      ...state,
      addFetching: true,
    };
  }
  case actionTypes.SEND_MESSAGE: {
    return {
      ...state,
      replyFetching: true,
    };
  }
  case actionTypes.CHANGE_TICKET_MESSAGE: {
    return {
      ...state,
      deleteFetching: true,
    };
  }

  case actionTypes.MASS_ASSIGN:
  case actionTypes.CHANGE_MASS_STATUS: {
    return {
      ...state,
      massFetching: true,
    };
  }

  case actionTypes.MASS_ASSIGN_SUCCESS:
  case actionTypes.CHANGE_MASS_STATUS_SUCCESS: {
    return {
      ...state,
      massFetching: false,
    };
  }

  case actionTypes.MASS_ASSIGN_ERROR:
  case actionTypes.CHANGE_MASS_STATUS_ERROR: {
    return {
      ...state,
      massFetching: false,
    };
  }

  case actionTypes.CHANGE_TICKET_MESSAGE_SUCCESS:
  case actionTypes.CHANGE_TICKET_MESSAGE_ERROR: {
    return {
      ...state,
      error: action.error_message,
      deleteFetching: false,
    };
  }
  case actionTypes.GET_LIST_SUCCESS: {
    return {
      ...state,
      statuses: state.statuses.length ? state.statuses : action.data?.statuses,
      isFetching: false,
    };
  }
  case actionTypes.GET_CONFIG_SUCCESS: {
    return {
      ...state,
    };
  }
  case actionTypes.GET_STATUSES_COUNTS_SUCCESS: {
    return {
      ...state,
      [action.field]: state[action.field].map((item) => {
        const finded = action.data.find((stat) => stat.id === item.id);
        if (finded) {
          return {
            ...item,
            count: finded.count,
          };
        }

        return item;
      }),
    };
  }
  case actionTypes.SEND_MESSAGE_ERROR: {
    return {
      ...state,
      error: action.error_message,
      replyFetching: false,
    };
  }
  case actionTypes.SEND_MESSAGE_SUCCESS: {
    return {
      ...state,
      error: action.error_message,
      replyFetching: false,
    };
  }
  case actionTypes.ASSIGN_TICKET_SUCCESS:
  case actionTypes.ASSIGN_TICKET_ERROR:
  case actionTypes.ADD_TICKET_ERROR:
  case actionTypes.ADD_TICKET_SUCCESS: {
    return {
      ...state,
      addFetching: false,
    };
  }
  case actionTypes.GET_TICKET_VIEW_SUCCESS: {
    return {
      ...state,
      isFetching: false,
      view: action.payload,
    };
  }
  case actionTypes.GET_TICKET_VIEW_ERROR: {
    return {
      ...state,
      isFetching: false,
      error: action.error_message,
    };
  }
  case actionTypes.GET_LIST_ERROR:
  case actionTypes.GET_CONFIG_ERROR: {
    return {
      ...state,
      isFetching: false,
      error: action.error_message,
    };
  }
  case actionTypes.GET_STAFF: {
    return {
      ...state,
      staffFetching: true,
    };
  }
  case actionTypes.GET_STAFF_SUCCESS: {
    return {
      ...state,
      staffFetching: false,
      staff: action.data,
    };
  }
  case actionTypes.GET_STAFF_ERROR: {
    return {
      ...state,
      staffFetching: false,
    };
  }
  case actionTypes.CLEAR_TICKET_VIEW: {
    return {
      ...state,
      view: {},
    };
  }
  case actionTypes.SET_ACTIVE_TICKET_FOR_TICKET_VIEW: {
    return {
      ...state,
      activeViewId: action.payload,
    };
  }
  case actionTypesGeneral.SET_CDN_DATA: {
    return {
      ...state,
      view: {
        ...state.view,
        cdn: action.payload,
      },
    };
  }
  default: {
    break;
  }
  }

  return state;
};

export default tickets;
